import { useState } from "react";
import Modal from "~/common/components/Modal";
import ResetPasswordForm from "~/features/auth/login/components/ResetPasswordForm";
import { useResetPasswordLogic } from "~/features/auth/login/hooks/useResetPasswordLogic";
import ResetSuccessContent from "~/features/auth/login/components/ResetSuccessContent";
import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { useTranslation } from "react-i18next";
import { Button, Stack } from "~/common/mui";

interface Props {
  close: () => void;
  initialEmail?: string;
  disableEdit?: boolean;
}

export const ResetPasswordPopup = ({ close, initialEmail, disableEdit }: Props) => {
  const { t } = useTranslation();

  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const { onResetSuccess } = useResetPasswordLogic();

  const successCb = (globalErrors: string[]) => {
    onResetSuccess(globalErrors);
    setShowSuccess(true);
  };

  const footer = (
    <Stack direction={"row"} gap={1}>
      {showSuccess && (
        <Button onClick={close} fullWidth={!isDesktop}>
          {t("close")}
        </Button>
      )}
      {!showSuccess && (
        <Button fullWidth={!isDesktop} data-test-id={"reset-submit"} type={"submit"} form="reset-password">
          {t("forgottenPwd.title")}
        </Button>
      )}
    </Stack>
  );

  return (
    <Modal onClose={close} footerChildren={footer} title={t("popup.forgottenPassword.title")}>
      {!showSuccess && (
        <ResetPasswordForm initialEmail={initialEmail} onSuccess={successCb} disableEdit={disableEdit} />
      )}
      {showSuccess && <ResetSuccessContent close={close} />}
    </Modal>
  );
};
export default ResetPasswordPopup;
